export function Footer() {
  return (
    <footer className="footer">
      <p>
        This material is unofficial and is not endorsed by FunPlus. aniimo.codes is an independent
        fan site with no affiliation to Pawprint Studio or FunPlus.
      </p>
      <p>
        Item icons are Aniimo artwork and remain the property of Pawprint Studio. Rewards are
        compiled from public trackers and can be wrong where those disagree.
      </p>
      <nav>
        <a href="https://www.aniimo.com/" target="_blank" rel="noopener noreferrer">
          Official site
        </a>
        <a href="https://x.com/Aniimo_EN" target="_blank" rel="noopener noreferrer">
          @Aniimo_EN
        </a>
        <a href="https://discord.com/invite/aniimo" target="_blank" rel="noopener noreferrer">
          Discord
        </a>
        <a href="#redeem">How to redeem</a>
      </nav>
    </footer>
  );
}
